import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { map, Observable } from 'rxjs';

import { VoidRefundReason } from 'src/app/models';
import { BaseService } from 'src/app/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class ReasonService extends BaseService {
  constructor(store: Store, private readonly http: HttpClient) {
    super(store);
  }

  getVoidReasons(): Observable<VoidRefundReason[]> {
    return this.http
      .get<{ pos_void_reasons: VoidRefundReason[] }>(
        this.getLocationUrl('void_reasons')
      )
      .pipe(map(({ pos_void_reasons }) => pos_void_reasons));
  }

  getRefundReasons(): Observable<VoidRefundReason[]> {
    return this.http
      .get<{ pos_refund_reasons: VoidRefundReason[] }>(
        this.getLocationUrl('refund_reasons')
      )
      .pipe(map(({ pos_refund_reasons }) => pos_refund_reasons));
  }
}
